var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overviewappusers-container"},[_vm._v(" 三类商户系统介绍 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }